module.exports = __webpack_public_path__ + "img/page4.a046db3f.png";